const counter = '.is-number-input';
const counterInput = 'input[type="number"]';
const counterUp = '.is-number-input__up';
const counterDown = '.is-number-input__down';

$(document).on('click', counterUp, function (e) {
    let input = $(this).closest(counter).find(counterInput);
    let val = parseFloat(input.val()) || parseInt(input.val());
    let min = input.data('min') || 0;
    let max = input.data('max') || Infinity;
    let step = input.data('step') || 1;

    if (val < max) {
        let newVal = Math.min(
            min + (Math.floor((val - min) / step) + 1) * step, // increment to next possible value that is a multiple of $step greater than $min
            max
        );
        input.val(newVal);
        input.change();
    }

    e.stopPropagation();
    e.preventDefault();
});

$(document).on('click', counterDown, function (e) {
    let input = $(this).closest(counter).find(counterInput);
    let val = parseFloat(input.val()) || parseInt(input.val());
    let min = input.data('min') || 0;
    let step = input.data('step') || 1;

    if (val > min) {
        let newVal = min + Math.max(
            Math.ceil((val - min) / step) - 1,
            0
        ) * step; // decrement to next possible value that is a multiple of $step greater than $min
        input.val(newVal);
        input.change();
    }

    e.stopPropagation();
    e.preventDefault();
});

